import { FC } from 'react';

// https://dev.to/
const Home: FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 44 44"
      width="24"
      height="24"
      aria-hidden="true"
      className="crayons-icon crayons-icon--default"
    >
      <g>
        <path
          fill="#A0041E"
          d="M13.344 18.702h-2a.5.5 0 01-.5-.5v-7a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v7a.5.5 0 01-.5.5z"
        ></path>
        <path fill="#FFE8B6" d="M9 20L22 7l13 13v17H9z"></path>
        <path fill="#FFCC4D" d="M22 20h1v16h-1z"></path>
        <path
          fill="#66757F"
          d="M35 21a.997.997 0 01-.707-.293L22 8.414 9.707 20.707a1 1 0 11-1.414-1.414l13-13a.999.999 0 011.414 0l13 13A.999.999 0 0135 21z"
        ></path>
        <path
          fill="#66757F"
          d="M22 21a.999.999 0 01-.707-1.707l6.5-6.5a1 1 0 111.414 1.414l-6.5 6.5A.997.997 0 0122 21z"
        ></path>
        <path fill="#C1694F" d="M14 30h4v6h-4z"></path>
        <path fill="#55ACEE" d="M14 21h4v4h-4zm12.5 0h4v4h-4zm0 9h4v4h-4z"></path>
        <path
          fill="#5C913B"
          d="M37.5 37.5A1.5 1.5 0 0136 39H8a1.5 1.5 0 010-3h28a1.5 1.5 0 011.5 1.5z"
        ></path>
      </g>
    </svg>
  );
};

export default Home;
